import CryptoJS from "crypto-js";

export const verifyHash = (responseData, hash)=>{
    const computedHash = CryptoJS.SHA256(JSON.stringify(responseData)).toString()
    if (computedHash === hash){
        return true;
    }
    return false;
}